import styles from "./StatisticsBarCard.module.scss";
import classNames from "classnames";
import { ArrowDownRightIcon, ArrowUpRightIcon } from "@vetty/icons";

export const StatisticsBarCard = ({
  id,
  icon,
  heading,
  value,
  percentage,
  variant,
}: {
  id: string;
  icon: React.ReactNode;
  heading: string;
  value: string;
  percentage: string;
  variant: "positive" | "negative" | "none";
}) => {
  return (
    <div className={styles["comp"]}>
      <div className={styles["comp__header"]}>
        {icon}

        <div className={styles["comp__header__heading"]}>{heading}</div>
      </div>

      <div className={styles["comp__content"]}>
        <div className={styles["comp__content__value"]}>{value}</div>
        {variant !== "none" && (
          <div
            className={classNames(
              styles["comp__content__badge"],
              styles[`comp__content__badge--${variant}`],
            )}
          >
            {variant === "positive" ? (
              <ArrowUpRightIcon style={{ width: 16, height: 16 }} />
            ) : (
              <ArrowDownRightIcon style={{ width: 16, height: 16 }} />
            )}
            <span className={styles["comp__content__badge__text"]}>
              {percentage}
            </span>
          </div>
        )}
      </div>

      <button className={styles["comp__button"]}>view more</button>
    </div>
  );
};
